import React from 'react';
import PlPastQuarterlySidebar from '../../../../molecules/pursuitLeader/components/plPastquarterlySideBar';
import {
  SidebarWrapper,
  SidebarTitle,
  ChevronIcon,
} from '../../../../atoms/sidebar/sidebar.styles';
import { isMobile, isTablet } from 'react-device-detect';
import DownChevron from '../../../../assets/icons/down-chevron.png';
import { Recoil_Summary_Drawer_Toggle } from '../../../../../recoil/recoil';
import { useRecoilState } from 'recoil';

const PlPastSideBar = props => {
  const [summaryDrawerToggle, setSummaryDrawerToggle] = useRecoilState(
    Recoil_Summary_Drawer_Toggle,
  );

  const onTitleClick = () => {
    isTablet || isMobile ? setSummaryDrawerToggle(!summaryDrawerToggle) : null;
  };

  return (
    <SidebarWrapper>
      <SidebarTitle onClick={onTitleClick}>
        {isMobile || isTablet ? (
          <ChevronIcon src={DownChevron} alt="Expand Icon" style={{ marginRight: '10px' }} />
        ) : null}
        {<h3>Summary</h3>}
      </SidebarTitle>
      <PlPastQuarterlySidebar data={props.data} />
    </SidebarWrapper>
  );
};

export default PlPastSideBar;
